/**
 * Validates that an image URL is a proper HTTP/HTTPS URL and not a Data URI
 * @param {string} url - The URL to validate
 * @returns {Object} - { isValid: boolean, error: string }
 */
export const validateImageUrl = (url) => {
  if (!url || !url.trim()) {
    return { isValid: true, error: '' } // Empty is allowed, field can be optional
  }

  const trimmedUrl = url.trim()

  // Check if it's a Data URI (reject these)
  if (trimmedUrl.startsWith('data:')) {
    return { 
      isValid: false, 
      error: 'Data URI formats are not allowed. Please use a direct HTTP/HTTPS image URL.' 
    }
  }

  // Check if it's a valid HTTP/HTTPS URL
  try {
    const urlObj = new URL(trimmedUrl)
    
    // Only allow http and https protocols
    if (urlObj.protocol !== 'http:' && urlObj.protocol !== 'https:') {
      return { 
        isValid: false, 
        error: 'Only HTTP or HTTPS URLs are allowed.' 
      }
    }

    return { isValid: true, error: '' }
  } catch (e) {
    return { 
      isValid: false, 
      error: 'Invalid URL format. Please enter a valid HTTP/HTTPS URL.' 
    }
  }
}

/**
 * Helper function to get error message for displaying in UI
 * @param {string} url - The URL to validate
 * @returns {string} - Error message or empty string
 */
export const getImageUrlError = (url) => {
  const { error } = validateImageUrl(url)
  return error
}

/**
 * Helper function to check if URL is valid
 * @param {string} url - The URL to validate
 * @returns {boolean} - True if valid
 */
export const isValidImageUrl = (url) => {
  const { isValid } = validateImageUrl(url)
  return isValid
}
